<script>
import { navigate } from "svelte-routing"
import Button from "./Button.svelte"

export let url = undefined
</script>

<Button {...$$restProps} on:click="{() => navigate(url)}" type="button" />
